import { inject } from 'vue'
import { tableSelectContext } from '../TableSelect'

export default function useTableSelect() {
  return inject(tableSelectContext)
}
